import { render, staticRenderFns } from "./Customizations.vue?vue&type=template&id=0ba042b7&scoped=true&"
import script from "./Customizations.vue?vue&type=script&lang=js&"
export * from "./Customizations.vue?vue&type=script&lang=js&"
import style0 from "./Customizations.vue?vue&type=style&index=0&id=0ba042b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba042b7",
  null
  
)

export default component.exports